import { RELATORIO_FINANCEIRO_ACCESS } from '../constants/modules';
import { isUsuarioUsoMuto } from '../utils';
import { isRoleAuditoriaNsir } from './auditoriaNsirPermission';
import { hasModuleConfiguration, isViniciusAdmin } from './moduleConfigurationPermission';

/**
 * Quem pode acessar /v2/relatorio-financeiro (menu + tela).
 * Requer module configuration RELATORIO_FINANCEIRO_ACCESS vinculada ao userId logado
 * (ou e-mail vinicius_admin).
 */
export function canViewFinanceiroReport({ authData, userRole, moduleConfigurations }) {
  if (isViniciusAdmin(authData)) return true;
  if (!authData?.id) return false;

  const role = userRole ?? authData.role;
  if (isUsuarioUsoMuto(authData.email) || isRoleAuditoriaNsir(role)) {
    return false;
  }

  return hasModuleConfiguration(moduleConfigurations, authData, RELATORIO_FINANCEIRO_ACCESS);
}
